import axios from 'axios'

/**
 * Extract a human-readable error message from a caught error,
 * preferring the `detail` field from an Axios error response.
 */
export function getApiErrorMessage(e: unknown, fallback: string): string {
  if (axios.isAxiosError(e)) {
    return e.response?.data?.detail || e.message
  }
  return fallback
}

export default getApiErrorMessage
